import InvoiceTemplate from './InvoiceTemplate.view';

export default InvoiceTemplate;
